import {GDPRManager} from "../g-d-p-r-manager";
import {IIdioma} from "services-comun/modules/net/idiomas";
import traduccionGDPR, {TraduccionCmpGdpr} from "cmp-web-translations/modules/traduccion/cmp/gdpr";
import traduccionSinLogo from "cmp-web-translations/modules/traduccion/cmp/gdpr/sin_logo";
import {site} from "../../../../context/context";

interface ILangGDPR {
    st_1: string;
    st_2: string;
    st_3: string;
    st_4: string;
    p_1: string;
    p_2: string;
    p_3: string;
    p_4: string;
    p_5: string;
    p_6: string;
    query_vendors: string;
    accept: string;
    reject: string;
    configure: string;
    altern: string;
}

export default class GDPRNoLogo extends GDPRManager {
    /* STATIC */
    private static _INSTANCE: GDPRNoLogo;

    public static instance(): GDPRNoLogo {
        return this._INSTANCE ??= new GDPRNoLogo();
    }

    /* INSTANCE */
    private _LANG: ILangGDPR|undefined;

    protected getTemplate(): Function {
        return require('../../../template/gdpr-no-logo.pug');
    }

    protected loadCSS(): void {
        require("cmp-web-templates/scss/gdpr.scss");
    }

    protected async loadLang(idioma: IIdioma): Promise<ILangGDPR> {
        if (!this._LANG) {
            const lang = traduccionGDPR(idioma);
            const isWeb: boolean = site.langKey() === 'web';
            const [
                st_1,
                st_2,
                st_3,
                st_4,
                p_1,
                p_2,
                p_3,
                p_4,
                p_5,
                p_6,
                query_vendors,
                accept,
                reject,
                configure,
                altern
            ] = [
                traduccionSinLogo(idioma).st_1,
                traduccionSinLogo(idioma).st_2,
                isWeb ? traduccionSinLogo(idioma).st_3 : traduccionSinLogo(idioma).st_3_app,
                traduccionSinLogo(idioma).st_4,
                isWeb ? traduccionSinLogo(idioma).p_1({
                    brand: site.gdprParams()?.['brand']||'nuestro sitio'
                }) : traduccionSinLogo(idioma).p_1_app({
                    brand: site.gdprParams()?.['brand']||'nuestro sitio'
                }),
                isWeb ? traduccionSinLogo(idioma).p_2 : traduccionSinLogo(idioma).p_2_app,
                isWeb ? traduccionSinLogo(idioma).p_3({
                    cookies_policy: site.gdprParams()?.['cookies_policy']
                }) : traduccionSinLogo(idioma).p_3_app({
                    cookies_policy: site.gdprParams()?.['cookies_policy']
                }),
                isWeb ? traduccionSinLogo(idioma).p_4 : traduccionSinLogo(idioma).p_4_app,
                isWeb ? traduccionSinLogo(idioma).p_5({
                    cookies_policy: site.gdprParams()?.['cookies_policy']
                }) : traduccionSinLogo(idioma).p_5_app({
                    cookies_policy: site.gdprParams()?.['cookies_policy']
                }),
                traduccionSinLogo(idioma).p_6,
                lang.query_n_vendors({
                    n: `${site.numVendors()}`
                }),
                this.getLangValue<TraduccionCmpGdpr>(lang, lang.accept, site.gdprParams()?.['lang.accept']),
                this.getLangValue<TraduccionCmpGdpr>(lang, lang.reject, site.gdprParams()?.['lang.reject']),
                this.getLangValue<TraduccionCmpGdpr>(lang, lang.configure, site.gdprParams()?.['lang.configure']),
                traduccionSinLogo(idioma).alternativamente
            ];
            this._LANG = {
                st_1,
                st_2,
                st_3,
                st_4,
                p_1,
                p_2,
                p_3,
                p_4,
                p_5,
                p_6,
                query_vendors,
                accept,
                reject,
                configure,
                altern
            };
        }
        return this._LANG;
    }
}
